/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// The pre-rebuild site registered a service worker (gatsby-plugin-offline)
// that serves its stale app shell as a blank page. This site has no service
// worker, so remove any leftover registration as soon as the new site runs.
// static/sw.js is the other half: it cleans up visitors still stuck on the
// old shell, who never get this far.
export const onClientEntry = () => {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator))
    return
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => registrations.forEach((r) => r.unregister()))
    .catch(() => {})
}
